import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    page:1,
    olddata:[]
   
    
}

const mutations={
   
    
    GoodsAgent(state,value){
       
        post(urls.admin.price.agent,value).then((result)=>{

            
            if(result.code==302){
              
                
                state.result= result
              
                console.log('state.olddata',state.olddata)


            }
            // state.result=result
          
            
          
         
             
          });
    },
    addPrice(state,value){
       
        post(urls.admin.price.add,value).then((result)=>{

            state.result= result
            // if(result.code==302 && result.code==201){
            //
            //
            //
            //
            //
            //
            // }
            // state.result=result
          
            
          
         
             
          });
    },
    getPriceDataIndex(state,val){
        

     
        post(urls.admin.price.index,val).then((result)=>{
          
          
          
          state.result=result

       
       
        
       
           
        });
        
    },
   
   
   
}
const  actions={
    getPriceDataAction(context,value){
        
        context.commit("getPriceDataIndex",value)
       
    },
    addPriceAction(context,value){
       
        
        context.commit("addPrice",value)
       
    },
    GoodsAgentAction(context,value){
       
        
        context.commit("GoodsAgent",value)
       
    },
   
    
   
  
    
  
    
   

}

export default {state,mutations,actions}